import * as actionTypes from "../_constants/auth.constants";
import { getCookie } from "../../App/utils/session";

const initialState = {
  user: null,
  token: getCookie("jwt") || ""
};
export function auth(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token
      };
    case actionTypes.REGISTER_SUCCESS:
      return { ...state, token: action.payload.token };
    case actionTypes.LOGOUT_SUCCESS:
      return { ...state, token: "" };

    default:
      return state;
  }
}
